module.exports = __webpack_public_path__ + "media/images/tmp/slide8-b25b190b75f4594563c0f58cf34cf8e9.jpg";